// FAZ-54 — Liste satırının "okundu" işareti (okunmamış beyaz / okunmuş soluk).
//
// Eskiden bu bilgi YALNIZ localStorage'daydı ("openedApps"). Sonuçları:
//   • sunucuya her build/deploy sonrası değil ama tarayıcı temizliğinde uçuyordu,
//   • başka bilgisayarda/tarayıcıda sıfırdan başlıyordu,
//   • gizli sekmede hiç tutulmuyordu.
// Kullanıcı "her seferinde hepsi beyaza dönüyor" dedi — sebebi buydu.
//
// Artık ASIL KAYNAK sunucudaki `read_by_me` alanı (ApplicationRead tablosu).
// localStorage yalnız GERİYE UYUM için okunur: sunucu alanı henüz gelmiyorsa
// (eski yanıt/önbellek) eski davranış korunur.

export const isApplicationRead = (app, openedIds = []) => {
  if (!app) return false;

  if (typeof app.read_by_me === "boolean") return app.read_by_me;

  const list = Array.isArray(openedIds) ? openedIds : [];
  return list.includes(app.id);
};

export default isApplicationRead;
